import React, { useEffect, useState } from "react";
import './main.css';
import { useGlobalContext } from '../../services/GlobalContext';
import AnimalCard from "../../components/animalCard";
import Header from '../../components/header';
import { AnimalAvatar } from "../../services/AnimalAvatar";

export default function AnimalMainPage() {
    const { data } = useGlobalContext();
    const [animalData, setAnimalData] = useState([]);

    useEffect(() => {
        if (data.policies) {
            const newAnimalData = data.policies[0].quote.protected_assets.map((item) => {
                return {
                    name: item.properties[0].data,
                    age: calculateAge(item.properties[3].data),
                    type: getLabel(item.properties[1].data, item.properties[1].options),
                    gender: item.properties[2].data,
                    color: getLabel(item.properties[6].data, item.properties[6].options),
                    breed: getLabel(item.properties[5].data, item.properties[5].options),
                    microchip_number: item.properties[4].data,
                    avatar_options : item.properties[1].options,
                };
            });

            setAnimalData(newAnimalData);
        }
    }, [data]);

    function calculateAge(birthdate) {
        const today = new Date();
        const birthDate = new Date(birthdate);

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        // If the current month is before the birth month, or it's the birth month but the day hasn't occurred yet, subtract 1 from the age
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    const getLabel = (value, options) => {
        const option = options.find(option => option.data === value);
        return option ? option.label : "tipo desconhecido";
    };

    return (
        <div className="w--100 h--100 animal_main">
            <Header />
            <div className="main_content">
                <div className="content_title font-18-900">
                    EXISTEM {animalData.length} ANIMAIS ASSOCIADOS A ESTA APÓLICE
                </div>
                <div className="content_card">
                    {animalData.length > 0 ? (
                        animalData.map((item) => (
                            <AnimalCard
                                key={item.microchip_number} // Adding key prop for list items
                                title={item.name}
                                count={item.age + ' anos'}
                                detail1={`${item.type} ${item.gender} ${item.color},`}
                                detail2={item.breed}
                                info={item.microchip_number}
                                isActive={1}
                                AnimalAvatar = {AnimalAvatar(item.type)}
                            />
                        ))
                    ) : (
                        <div>Nenhum animal encontrado</div> // Optional: Provide feedback if no animals are found
                    )}
                </div>
            </div>
        </div>
    );
}
